module.exports = __webpack_public_path__ + "img/logo_flat.a0a924e8.svg";